import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-param-reassign */
var removeAllSpecialCharacters = function removeAllSpecialCharacters(string) {
  return string.replace(/[^a-zA-Z0-9 ]/g, '');
};

var getAcronym = function getAcronym(string) {
  return removeAllSpecialCharacters(string).match(/\b(\w)/g).join('').toUpperCase();
};

var randomString = function randomString() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
  var result = '';
  var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var length = size;

  while (length > 0) {
    length -= 1;
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  }

  return result;
};

var findWindow = typeof window === 'undefined' ? {} : window; // eslint-disable-line

var allPresent = function allPresent(args) {
  return args.every(function (arg) {
    return arg;
  });
};

var trackingHelper = function trackingHelper() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var page = options.page,
      pageId = options.pageId,
      placement = options.placement,
      innerPlacement = options.innerPlacement,
      sectionTitle = options.sectionTitle,
      strategy = options.strategy,
      itemId = options.itemId,
      categoryName = options.categoryName;
  var id = categoryName || itemId;
  var paramList = [page, pageId, placement, innerPlacement, sectionTitle, strategy, id];
  var rndStr = randomString();
  var list = [placement, innerPlacement, sectionTitle, strategy, id, rndStr];
  var data = list.join(':');
  var queryParams = "?rec=".concat(page, "[").concat(pageId, "]:").concat(data);
  var queryString = allPresent(paramList) ? queryParams : '';
  return queryString;
};

var ensureStructure = function ensureStructure(window) {
  /* eslint-disable */
  window.digitalData = window.digitalData || {};
  window.digitalData.page = window.digitalData.page || {};
  window.digitalData.page.lightBox = window.digitalData.page.lightBox || {};
  window.digitalData.page.lightBox.product = window.digitalData.page.lightBox.product || [];
  window.digitalData.page.lightBox.module = window.digitalData.page.lightBox.module || [];
  window.digitalData.event = window.digitalData.event || [];

  window.digitalData.track = window.digitalData.track || function () {};
  /* eslint-enable */

};

var byId = function byId(id) {
  return function (object) {
    return object.id === id;
  };
};

var reducer = function reducer(accumulator, value) {
  var match = accumulator.find(byId(value.id));

  if (match) {
    match.quantity += value.quantity;
  } else {
    accumulator.push(value);
  }

  return accumulator;
};

var onAddToTrolleyModalOpen = function onAddToTrolleyModalOpen(product) {
  var window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : findWindow;
  return function (clickOrigin) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function () {
      ensureStructure(window);
      window.digitalData.page.lightBox.type = 'ATT'; // eslint-disable-line

      window.digitalData.page.lightBox.product = product; // eslint-disable-line

      var event = {
        eventInfo: {
          eventName: 'addToTrolley',
          eventAction: 'Add to Trolley'
        },
        attributes: _objectSpread({
          clickOrigin: clickOrigin,
          product: product.reduce(reducer, [])
        }, options)
      };
      window.digitalData.event.push(event);
      window.digitalData.track(event.eventInfo.eventName);
    };
  };
};

var onWarrantiesLoaded = function onWarrantiesLoaded(warrantyProducts, hostProduct, quantity) {
  var window = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : findWindow;
  var id = hostProduct.data.attributes.partNumber,
      included = hostProduct.included;
  var hostPrices = included.find(function (item) {
    return item.type === 'prices';
  });
  var price = hostPrices === null || hostPrices === void 0 ? void 0 : hostPrices.attributes.now;
  var monthlyCareOffered = !!warrantyProducts.find(function (warranty) {
    return warranty.type.startsWith('monthly_care');
  });
  var termCareOffered = !!warrantyProducts.find(function (warranty) {
    return warranty.type === 'warranties';
  });
  var event = {
    eventInfo: {
      eventName: 'attWarrantiesOffered',
      eventAction: 'Add to Trolley Warranties Offered'
    },
    attributes: {
      product: [{
        id: id,
        price: price,
        quantity: quantity,
        monthlyCareOffered: monthlyCareOffered,
        termCareOffered: termCareOffered
      }]
    }
  };
  ensureStructure(window);
  window.digitalData.event.push(event);
  window.digitalData.track(event.eventInfo.eventName);
};

var onRecommendationsLoaded = function onRecommendationsLoaded(recommendations) {
  var window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : findWindow;
  var _recommendations$warr = recommendations.warrantyItems,
      warrantyItems = _recommendations$warr === void 0 ? [] : _recommendations$warr,
      _recommendations$extr = recommendations.extraItems,
      extraItems = _recommendations$extr === void 0 ? [] : _recommendations$extr,
      _recommendations$cate = recommendations.categoryItems,
      categoryItems = _recommendations$cate === void 0 ? [] : _recommendations$cate,
      _recommendations$warr2 = recommendations.warrantyItemsMeta,
      warrantyItemsMeta = _recommendations$warr2 === void 0 ? {
    placementTitle: 'Protect your product'
  } : _recommendations$warr2,
      _recommendations$extr2 = recommendations.extraItemsMeta,
      extraItemsMeta = _recommendations$extr2 === void 0 ? {
    placementTitle: ''
  } : _recommendations$extr2,
      _recommendations$cate2 = recommendations.categoryItemsMeta,
      categoryItemsMeta = _recommendations$cate2 === void 0 ? {
    placementTitle: ''
  } : _recommendations$cate2;
  var sectionPlacement = 'attLightbox';
  var strategy = 'xsell';

  var buildItem = function buildItem(_ref) {
    var title = _ref.placementTitle,
        pageCategory = _ref.pageCategory;
    return function (product) {
      var placement = product.placement,
          model = product.model;
      var item = {
        title: title,
        sectionTitle: getAcronym(title),
        product: product,
        placement: placement,
        model: model,
        sectionPlacement: sectionPlacement,
        strategy: strategy,
        pageCategory: pageCategory
      };
      return item;
    };
  };

  var buildCategoryItem = function buildCategoryItem(_ref2) {
    var title = _ref2.placementTitle,
        pageCategory = _ref2.pageCategory;
    return function (category) {
      var placement = category.placement,
          model = category.model,
          attributes = category.attributes;
      var name = attributes.name;
      var item = {
        title: title,
        sectionTitle: getAcronym(title),
        category: _objectSpread(_objectSpread({}, category), {}, {
          name: name
        }),
        placement: placement,
        model: model,
        sectionPlacement: sectionPlacement,
        strategy: strategy,
        pageCategory: pageCategory
      };
      return item;
    };
  };

  ensureStructure(window);
  var pageCategory = window.digitalData.page.category && window.digitalData.page.category.pageType || '';
  var warrantyItemList = warrantyItems.map(buildItem(_objectSpread(_objectSpread({}, warrantyItemsMeta), {}, {
    pageCategory: pageCategory
  })));
  var extraItemList = extraItems.map(buildItem(_objectSpread(_objectSpread({}, extraItemsMeta), {}, {
    pageCategory: pageCategory
  })));
  var categoryItemList = categoryItems.map(buildCategoryItem(_objectSpread(_objectSpread({}, categoryItemsMeta), {}, {
    pageCategory: pageCategory
  }))); // eslint-disable-next-line no-param-reassign

  window.digitalData.page.lightBox.module = [].concat(_toConsumableArray(warrantyItemList), _toConsumableArray(extraItemList), _toConsumableArray(categoryItemList));
  window.digitalData.track('addToTrolleyLbPage');
}; // Method used for generating the Essential Extras bundle tracking data in click event


var generatingEssentialExtraBundleData = function generatingEssentialExtraBundleData(_ref3) {
  var accessory = _ref3.accessory,
      product = _ref3.product;
  if (!accessory || !product) return undefined;
  return {
    bundleId: "".concat(product.id, "+").concat(accessory.id),
    bundleItems: {
      main: {
        id: product.id,
        price: product.price,
        quantity: product.quantity,
        name: product.name
      },
      additional: [{
        id: accessory.id,
        price: accessory.price,
        quantity: accessory.quantity,
        name: accessory.name
      }]
    },
    bundleType: 'lb_essential_extras',
    bundleSize: 1,
    bundlePlacement: 'hero'
  };
};

var onRecommendationClicked = function onRecommendationClicked(info) {
  var window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : findWindow;
  var itemType = info.itemType,
      subType = info.subType,
      origin = info.origin,
      moduleIndex = info.moduleIndex,
      id = info.id,
      quantity = info.quantity,
      price = info.price;
  var type = subType || itemType;

  if (itemType === 'category') {
    return;
  }

  var event = {
    eventInfo: {
      eventName: 'addToTrolley',
      eventAction: 'Add to Trolley'
    },
    attributes: {
      clickOrigin: origin || "AttLb:".concat(type, "ATT"),
      moduleIndex: moduleIndex,
      product: [{
        id: id,
        price: price,
        quantity: quantity
      }]
    }
  }; // Additional tracking data for Essential Extra bundles only

  if (itemType === 'extra' && subType === 'extras') {
    var name = info.name,
        mainProduct = info.mainProduct; // Generating Essential extras bundle data

    var bundle = generatingEssentialExtraBundleData({
      product: _objectSpread({}, mainProduct),
      accessory: {
        id: id,
        price: price,
        quantity: quantity,
        name: name
      }
    }); // Adding bundle and main product data to the event attributes

    event.attributes = _objectSpread(_objectSpread({}, event.attributes), {}, {
      product: [{
        id: id,
        price: price,
        quantity: quantity
      }, {
        id: mainProduct.id,
        price: mainProduct.price,
        quantity: mainProduct.quantity
      }]
    }, bundle);
  }

  ensureStructure(window);
  window.digitalData.event.push(event);
  window.digitalData.track(event.eventInfo.eventName);
};

var onWarrantyIPDLinkClicked = function onWarrantyIPDLinkClicked(info) {
  var window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : findWindow;
  var isMonthlyCare = info.isMonthlyCare,
      products = info.products;
  var eventName = isMonthlyCare ? 'attLbMonthlyCareAccordionIPIDdocumentLink' : 'attLbTermCareAccordionIPIDdocumentLink';
  var eventAction = isMonthlyCare ? 'Add to Trolley Lightbox Monthly Care Accordion IPID Document Link' : 'Add to Trolley Lightbox Term Care Accordion IPID Document Link';
  var event = {
    eventInfo: {
      eventName: eventName,
      eventAction: eventAction
    },
    attributes: {
      product: products
    }
  };
  ensureStructure(window);
  window.digitalData.event.push(event);
  window.digitalData.track(event.eventInfo.eventName);
}; // TODO uni tests (not done under time constraints)


var onWarrantySelected = function onWarrantySelected(_ref4) {
  var id = _ref4.id,
      price = _ref4.price,
      quantity = _ref4.quantity;
  var window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : findWindow;
  var event = {
    eventInfo: {
      eventName: 'selectWarranty',
      eventAction: 'Select Warranty'
    },
    attributes: {
      product: [],
      clickOrigin: 'AttLb:warrantiesSelect'
    }
  };
  event.attributes.product.push({
    id: id,
    price: price,
    quantity: quantity
  });
  ensureStructure(window);
  window.digitalData.event.push(event);
  window.digitalData.track(event.eventInfo.eventName);
};

var onAddToTrolleyModalShut = function onAddToTrolleyModalShut() {
  var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : findWindow;
  ensureStructure(window);
  window.digitalData.page.lightBox = {}; // eslint-disable-line
};

var onAddToTrolleyExtraModalShut = function onAddToTrolleyExtraModalShut() {
  var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : findWindow;
  var event = {
    eventInfo: {
      eventName: 'close_essentialExtrasATTLb',
      eventAction: 'Close Essential Extras ATT Lightbox'
    }
  };
  ensureStructure(window);
  window.digitalData.event.push(event);
  window.digitalData.track(event.eventInfo.eventName);
  window.digitalData.page.lightBox = {}; // eslint-disable-line
};

var onOpenExtraModal = function onOpenExtraModal() {
  var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : findWindow;
  ensureStructure(window);
  window.digitalData.page.lightBox.pageName = 'ar:pdp:essential-extras:attLightbox:'; // eslint-disable-line

  window.digitalData.page.lightBox.type = 'essential-extras'; // eslint-disable-line

  var event = {
    eventInfo: {
      eventName: 'essentialExtrasATTLbPage',
      eventAction: 'Essential Extras'
    }
  };
  window.digitalData.track(event.eventInfo.eventName);
};

var onGoToTrolleyButtonClicked = function onGoToTrolleyButtonClicked() {
  var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : findWindow;
  var event = {
    eventInfo: {
      eventName: 'goToTrolley_essentialExtrasATTLb',
      eventAction: 'Go To Trolley Essential Extras ATT Lightbox'
    }
  };
  ensureStructure(window);
  window.digitalData.event.push(event);
  window.digitalData.track(event.eventInfo.eventName);
};

var onAddToTrolleyModalError = function onAddToTrolleyModalError(product, errorStatusCode, errorStatusText) {
  var window = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : findWindow;
  return function (clickOrigin) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function () {
      var event = {
        eventInfo: {
          eventName: 'addToTrolley_error',
          eventAction: 'Add to Trolley ERROR'
        },
        attributes: _objectSpread({
          clickOrigin: clickOrigin,
          product: product.reduce(reducer, []),
          errorType: errorStatusCode,
          error: errorStatusText
        }, options)
      };
      ensureStructure(window);
      window.digitalData.event.push(event);
      window.digitalData.track(event.eventInfo.eventName);
    };
  };
};

export { onAddToTrolleyModalOpen, onRecommendationsLoaded, onRecommendationClicked, onAddToTrolleyModalShut, onWarrantyIPDLinkClicked, onWarrantySelected, onWarrantiesLoaded, onOpenExtraModal, onAddToTrolleyExtraModalShut, onGoToTrolleyButtonClicked, onAddToTrolleyModalError };
export default trackingHelper;